import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SearchModel, SearchResultModel } from 'src/common/components';

const localApiUrl = `${environment.apiUrl}/Test`;

@Injectable()
export class TestService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<any>> {
    return this.http.post<SearchResultModel<any>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<any[]> {
    return this.http.get<any[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<any> {
    return this.http.get<any>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
    return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }
}
